var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionableAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32.583 32.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-0.75 -0.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24884",
    "data-name": "Path 24884",
    d: "M1,29H32.967v2.131H1Z",
    transform: "translate(0 1.839)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24885",
    "data-name": "Path 24885",
    d: "M4.2,27.642a3.186,3.186,0,0,0,2.333-5.367l5.455-8.58a3.023,3.023,0,0,0,2.107-.226l4.278,4.279a3.144,3.144,0,0,0-.32,1.369A3.2,3.2,0,1,0,23.7,17.085l5.541-9.741a3.221,3.221,0,1,0-1.86-1.04l-5.515,9.681a3.213,3.213,0,0,0-.616-.063,3.144,3.144,0,0,0-1.369.32L15.6,11.963a3.144,3.144,0,0,0,.32-1.369,3.2,3.2,0,1,0-6.393,0,3.163,3.163,0,0,0,.673,1.939l-5.57,8.76a3.2,3.2,0,0,0-.432-.044,3.2,3.2,0,0,0,0,6.393Zm17.049-7.459a1.066,1.066,0,1,1,1.066-1.066A1.066,1.066,0,0,1,21.246,20.183ZM29.77,3.134A1.066,1.066,0,1,1,28.7,4.2,1.066,1.066,0,0,1,29.77,3.134ZM12.721,9.528a1.066,1.066,0,1,1-1.066,1.066A1.066,1.066,0,0,1,12.721,9.528ZM4.2,23.38a1.066,1.066,0,1,1-1.066,1.066A1.066,1.066,0,0,1,4.2,23.38Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionableAnalytics);
export default __webpack_public_path__ + "static/media/ActionableAnalytics.40f907b0df19af6d5c7a1cf03b011a79.svg";
export { ForwardRef as ReactComponent };